/**
 * 关于页懒加载壳（14.35a；AccountSecurityLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function AboutLazy() {
  const { mod } = useLazyModule(() => import('./AboutPage'));
  if (mod === null) return <div data-testid="about-loading-shell">加载中…</div>;
  return <mod.AboutPage />;
}
